<style scoped>
.addMargin {
  margin-top: 10px;
}
.grayOut {
  color: rgb(170, 170, 170);
}
.home-header{
  width: 100%;
  padding: 15px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.not-a-member{
  background: #fff;
  text-align: center;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.user-group{
  width: 60px;
  height: 60px;
  border-radius: 60px;
}
</style>

<template>
  <app-layout class="groups-page-template">
    <Icon v-if="showGroup" v-on:click="setShowGroup(false)" type="chevron-left" style="position: fixed;top: 20px;z-index: 99;left: 20px;color: #000;font-size: 1.5em;"></Icon>
    <Row type="flex" justify="center">
      <!-- <div class="home-header">
        <Button style="float:right" size="large" @click="setMemberMethod('signup')" v-if="userInfo && userInfo.user_type === 'guest'" type="error">Join</Button>
        <Button style="float:right;" size="large" type="primary" v-if="userInfo && userInfo.user_type != 'guest' && !showGroup" v-on:click="setShowGroup(true)">Add</Button>
        <router-link to="/profile" style="float:left;margin-right:10px">
            <Avatar size="large" v-if="userInfo.user_type === 'guest'" :src="userInfo.avatar" style="border:1px solid #ddd;background: rgb(50, 51, 53);"></Avatar>
            <Avatar size="large" class="user-group" v-else :src="userDisplayImage(userInfo)" style="border:1px solid #ddd;background: white;"></Avatar>
        </router-link>
        <h2 align="left" :style="{lineHeight: ( userInfo && userInfo.user_type === 'guest' ) ? '18px':'14px'}">
          <small><a v-if="userInfo && userInfo.user_type === 'guest'" @click="setMemberMethod('signin')" style="font-size:12px">Already a Member?</a></small><br/>
          <span v-if="userInfo && userInfo.user_type === 'guest'" style="color:#aaa;font-size:12px">Guest</span>
          <span v-else>{{userInfo.display_name}}
          </span>
        </h2>
        <p  v-if="userInfo && userInfo.user_type != 'guest'" style="font-size: 0.9em; margin-top: 5px;">
          Groups and Organizations <br/> you belong to or follow.
        </p>
        <p align="left" style="line-height:10px">{{(brandPlanInfo.title) ? '': ""}}</p>
      </div> -->
      <Col :span="24" v-for="(item,k) in menuList" :key="k" :class="(item.break) ? 'addMargin': ''" v-if="showGroup">
        <Card :class="(item.isGray) ? 'grayOut': ''" shadow :style="{borderRadius: '0', borderTop: '0px solid #F2F2F2', cursor: 'pointer'}" :padding="15">
          <div @click="viewPage(item.link)">
            <Avatar :src="item.icon" class="avatar-icon" style="background:#333;vertical-align:middle;"></Avatar> &nbsp; {{item.label}}
          </div>
        </Card>
      </Col>
      <Col :span="24" v-if="!showGroup">
        <div>
          <ResourceListItemComponent></ResourceListItemComponent>
        </div>
      </Col>
      <div class="not-a-member" v-if="userInfo.user_type === 'guest'">
        <img alt=" " :src="sadIcon" style="position: absolute;top: 58px;">
        <p style="margin-top: 54px;">Sharpen Colleges connects you to People, Groups and Organizations based on your interests and demographic data.</p><br/>
        <p>As a Guest, you unfortunately do not belong to any Group or Organization.</p><br/>
        <p>Please register.</p>
      </div>
    </Row>
    <ReportModalComponent :type="reportType" v-if="reportType" @closeModal="reportType = null"></ReportModalComponent>
  </app-layout>
</template>

<script>
import Utils from '@/utils.js'
import VueCookie from 'vue-cookie'
import ResourceListItemComponent from "@/components/ResourceListItemComponent";
import ReportModalComponent from '@/components/ReportModalComponent'

export default {
  name: 'GroupsComponent',
  components: {
    ResourceListItemComponent,
    ReportModalComponent
  },
  computed: {
    userInfo: {
      get() { return this.$store.state.user.info}
    },
    brandPlanInfo: {
      get () {
        return this.$store.state.user.brandPlan
      }
    },
    sadIcon: {
      get() {
        return require('@/assets/sad.png');
      }
    },
    showGroup: {
      get() {
        return this.$store.state.publicModule.showGroup
      }
    }
  },
  data () {
    return {
      menuList: [
        { icon: require('@/assets/resources/Advocacies.png'), label: 'Advocacies', link: '/advocacies'},
        { icon: require('@/assets/resources/Organizations.png'), label: 'Organizations', link: '/organization' },
        { icon: require('@/assets/resources/Special-Projects.png'), label: 'Special Projects', link: '/resources/list?type=special_project' },
        // { icon: require('@/assets/resources/City.png'), label: 'City', link: '/resources/list?type=city' },
        // { icon: require('@/assets/resources/Region.png'), label: 'Region', link: '/resources/list?type=region' },
        // { icon: require('@/assets/resources/Province.png'), label: 'Province', link: '/resources/list?type=province' },
      ],
      showGroups: false,
      reportType: null
    }
  },
  methods: {
    viewPage (v) {
      console.log(v)
      this.$router.push({ path: v })
    },
    setMemberMethod (type) {
      let prescriptionCode =
        'code' in this.$route.query && this.$route.query.code
          ? this.$route.query.code
          : null
      let prescription =
        'prescription' in this.$route.query && this.$route.query.prescription
          ? this.$route.query.prescription
          : null
      let pType =
        'ptype' in this.$route.query && this.$route.query.ptype
          ? this.$route.query.ptype
          : null

      if (pType && prescription && prescriptionCode && type) {
        this.$router.replace({
          path:
            '/login?ptype=' +
            pType +
            '&type=' +
            type +
            '&prescription=' +
            prescription +
            '&code=' +
            prescriptionCode
        })
      } else if (!pType && !prescription && !prescriptionCode && type) {
        this.$router.replace({ path: '/login?type=' + type })
      } else if (!type && pType && prescriptionCode && prescription) {
        this.$router.replace({
          path:
            '/login?prescription=' +
            prescription +
            '&code=' +
            prescriptionCode +
            '&ptype=' +
            pType
        })
      } else this.$router.replace({ path: '/login' })
      // this.reportType = type
      // if(type == 'signin' || type == 'signup')
      //   this.$store.commit('menu/setShowWizardModalComponent', true)
    },
    onClickGroup(){

    },
    setShowGroup(b){
      this.$store.commit('publicModule/setShowGroup', b);
    },
    userDisplayImage(user) {
      return Utils.getDisplayImage('user', user, 'small')
    }
  },
}
</script>
